import { withDefault, StringParam } from 'use-query-params';
import {
  CustomStringParam,
  FilterType,
  SchemaFilterType,
  SortDir,
} from '@ui/src';
import { AgreementClientType, AgreementStatus, AgreementType } from '../types';

export const agreementsListColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'type',
    label: 'Document Type',
    sortable: true,
  },
  {
    name: 'client',
    label: 'Customer Type',
    sortable: true,
  },
  {
    name: 'createdAt',
    label: 'Date created',
    sortable: true,
  },
  {
    name: 'status',
    label: 'Status',
  },
  {
    name: 'startAt',
    label: 'Date applied',
    sortable: true,
  },
  {
    name: 'version',
    label: 'Version',
    sortable: true,
  },
  {
    name: 'archivedAt',
    label: 'Date archivated',
    sortable: true,
  },
];

export const agreementsListColumnsLabels = {
  type: 'Document Type',
  client: 'Customer Type',
  startAt: 'Date applied',
  status: 'Status',
};

export const agreementsListDefaultSorter = {
  sortProp: agreementsListColumns[3].name,
  sortDir: SortDir.ASC,
};

export const agreementsListSchema = {
  type: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  client: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  startAt: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['startAtFrom', 'startAtTo'],
  },
  startAtFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  startAtTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  status: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  sortProp: {
    value: withDefault(StringParam, agreementsListDefaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, agreementsListDefaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};

export const agreementsListFiltersSchema = [
  {
    name: 'type',
    type: FilterType.CHECKBOX,
    fields: [
      {
        name: 'type',
        title: 'General T&Cs',
        value: AgreementType.GENERAL_T_AND_CS,
      },
      {
        name: 'type',
        title: 'Privacy Notice',
        value: AgreementType.PRIVACY_NOTICE,
      },
      {
        name: 'type',
        title: 'Annex 1',
        value: AgreementType.ANNEX_1,
      },
      {
        name: 'type',
        title: 'Annex 2',
        value: AgreementType.ANNEX_2,
      },
      {
        name: 'type',
        title: 'Annex 3',
        value: AgreementType.ANNEX_3,
      },
      {
        name: 'type',
        title: 'Annex 4',
        value: AgreementType.ANNEX_4,
      },
      {
        name: 'type',
        title: 'Annex 5',
        value: AgreementType.ANNEX_5,
      },
      {
        name: 'type',
        title: 'Annex 6',
        value: AgreementType.ANNEX_6,
      },
      {
        name: 'type',
        title: 'Annex 7',
        value: AgreementType.ANNEX_7,
      },
      {
        name: 'type',
        title: 'Annex 8',
        value: AgreementType.ANNEX_8,
      },
    ],
  },
  {
    name: 'client',
    type: FilterType.CHECKBOX,
    fields: [
      {
        name: 'client',
        title: 'Individual',
        value: AgreementClientType.INDIVIDUAL,
      },
      {
        name: 'client',
        title: 'Corporate',
        value: AgreementClientType.CORPORATE,
      },
      {
        name: 'client',
        title: 'Company official',
        value: AgreementClientType.COMPANY_OFFICIAL,
      },
    ],
  },
  {
    name: 'status',
    type: FilterType.RADIO,
    fields: [
      {
        name: 'status',
        title: 'Published',
        value: AgreementStatus.PUBLISHED,
      },
      {
        name: 'status',
        title: 'Archived',
        value: AgreementStatus.ARCHIVED,
      },
    ],
  },
  {
    name: 'startAt',
    type: FilterType.DATE_RANGE,
  },
];
